import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RxjsService, CustomDirectiveConfig, setMinMaxValidator, OtherService, CrudService, ModulesBasedApiSuffix, IApplicationResponse, prepareRequiredHttpParams, NO_DATA_FOUND_MESSAGE, toRoundOffWithMathRound } from '@app/shared';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared/enum.ts/technical.enum';

@Component({
    selector: 'app-discount-on-warranty-maintenance-modal',
    templateUrl: './discount-on-warranty-maintenance-modal.component.html'
})
export class DiscountOnWarrantyMaintenanceModalComponent implements OnInit {

    serviceForDiscountForm: FormGroup;
    isNumericOnly = new CustomDirectiveConfig({ isANumberWithZero: true });
    NO_DATA_FOUND_MESSAGE = NO_DATA_FOUND_MESSAGE;

    constructor(
        @Inject(MAT_DIALOG_DATA) public popupData: any,
        private formBuilder: FormBuilder,
        private rxjsService: RxjsService,
        private dialogRef: MatDialogRef<DiscountOnWarrantyMaintenanceModalComponent>,
        private crudService: CrudService,
        private otherService: OtherService) {
        this.rxjsService.setDialogOpenProperty(true);
    }

    ngOnInit(): void {
        this.createForm();
        this.onLoadValue();
    }

    createForm() {
        this.serviceForDiscountForm = this.formBuilder.group({});
        this.serviceForDiscountForm.addControl('stocksForWarrantyList', this.formBuilder.array([]));
    }

    onLoadValue() {
        this.rxjsService.setGlobalLoaderProperty(true);
        this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN,
            TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_WARRANTY, undefined, false, prepareRequiredHttpParams({billOfMaterialId: this.popupData?.billOfMaterialId}))
        .subscribe((response: IApplicationResponse) => {
            if (response?.isSuccess && response?.statusCode == 200) {
                this.onPatchValue(response?.resources);
            }
            this.rxjsService.setGlobalLoaderProperty(false);
        })
    }

    onPatchValue(response) {
        response?.forEach(element => {
            let stocksAppliedForWarrantyFormGroup = this.formBuilder.group({
                billOfMaterialItemId: [{ value: element['billOfMaterialItemId'], disabled: true }],
                itemCode: [{ value: element['itemCode'], disabled: true }],
                itemName: [{ value: element['itemName'], disabled: true }],
                unitPrice: [{ value: this.otherService.transformCurrToNum(toRoundOffWithMathRound(element['unitPrice'])), disabled: true }],
                subTotal: [{ value: element['subTotal'], disabled: true }],
                maxWarrantyQty: [{ value: element['maxWarrantyQty'], disabled: true }],
                warrantyQty: [element['warrantyQty'], [Validators.required]],
            });
            stocksAppliedForWarrantyFormGroup = setMinMaxValidator(stocksAppliedForWarrantyFormGroup, [
                { formControlName: 'warrantyQty', compareWith: 'maxWarrantyQty', type: 'minEqual' } // compareWith: 'request'
            ]);
            stocksAppliedForWarrantyFormGroup.get('warrantyQty').valueChanges.subscribe(qty => {
                qty = +qty;
                if (qty > 0 && qty <= stocksAppliedForWarrantyFormGroup.get('maxWarrantyQty').value) {
                    stocksAppliedForWarrantyFormGroup.get('subTotal').setValue(+(toRoundOffWithMathRound(qty * +stocksAppliedForWarrantyFormGroup.get('unitPrice')?.value)));
                } else if (!qty) {
                    stocksAppliedForWarrantyFormGroup.get('subTotal').setValue(0);
                }
            });
            this.stocksForWarrantyFormArray.push(stocksAppliedForWarrantyFormGroup);
        });
    }

    get stocksForWarrantyFormArray(): FormArray {
        if (this.serviceForDiscountForm !== undefined) {
            return (<FormArray>this.serviceForDiscountForm.get('stocksForWarrantyList'));
        }
    }

    getValue() {
        let reqBomObj = [];
        this.stocksForWarrantyFormArray.getRawValue()?.forEach((el) => {
            reqBomObj.push({
                billOfMaterialItemId: el?.billOfMaterialItemId,
                warrantyQty: el?.warrantyQty,
                modifiedUserId: this.popupData?.userId,
            })
        })
        return reqBomObj;
    }

    onClose() {
        this.dialogRef.close(false);
        this.rxjsService.setDialogOpenProperty(false);
    }

    updateWarrantyData() {
        if (this.serviceForDiscountForm.invalid) {
            this.serviceForDiscountForm.markAllAsTouched();
            return;
        }
        this.rxjsService.setGlobalLoaderProperty(true);
        const reqObj = this.getValue();
        this.crudService.update(ModulesBasedApiSuffix.TECHNICIAN,
            TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_WARRANTY, reqObj)
            .subscribe((res: IApplicationResponse) => {
                if (res?.isSuccess && res?.statusCode == 200) {
                    this.dialogRef.close(true);
                    this.rxjsService.setDialogOpenProperty(false);
                }
                this.rxjsService.setGlobalLoaderProperty(false);
            })
    }

}